function isIOS() {
    if (
        navigator.userAgent.indexOf("iPhone") != -1 ||
        navigator.userAgent.indexOf("iPad") != -1 ||
        navigator.userAgent.indexOf("iPod") != -1
    ) {
        return true;
    }
    return false;
}

function getOSSingleChar() {
    var a = "U";
    if (-1 != navigator.appVersion.indexOf("Win")) {
        a = "W";
    } else if (isIOS()) {
        a = "I";
    } else if (-1 != navigator.appVersion.indexOf("Mac")) {
        a = "M";
    } else if (-1 != navigator.appVersion.indexOf("Android")) {
        a = "A";
    } else if (-1 != navigator.appVersion.indexOf("X11")) {
        a = "L";
    } else if (-1 != navigator.appVersion.indexOf("Linux")) {
        a = "L";
    }
    return a;
}

module.exports = { isIOS, getOSSingleChar };
